import { Link, useLocation } from "react-router-dom";
import { Phone, ArrowRight, MessageSquareText } from "lucide-react";
import { CONTACT } from "@/lib/brand";

/**
 * StickyCTA
 * - Mobile: bottom bar with Get Quote (primary) + Call Now
 * - Desktop: floating pill on the bottom-left ("Get Quote in 60 seconds")
 * Hidden on /contact (form already on page).
 */
export default function StickyCTA() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/contact")) return null;

  return (
    <>
      {/* Mobile bottom spacer so fixed bar doesn't cover footer */}
      <div className="md:hidden h-20" aria-hidden />

      {/* Mobile bottom bar */}
      <div
        data-testid="sticky-cta-mobile"
        className="md:hidden fixed bottom-0 inset-x-0 z-[60] bg-white/95 backdrop-blur-md border-t border-slate-200 px-3 py-2.5"
        style={{
          paddingBottom: "max(0.625rem, env(safe-area-inset-bottom))",
        }}
      >
        <div className="flex items-center gap-2">
          <a
            href={`tel:${CONTACT.phoneTel}`}
            data-testid="sticky-cta-call-mobile"
            aria-label="Call Clean Me"
            className="inline-flex items-center justify-center h-12 w-14 rounded-2xl bg-slate-900 text-white shadow-soft active:scale-[0.98] transition-transform flex-shrink-0"
          >
            <Phone className="h-5 w-5" />
          </a>
          <Link
            to="/contact"
            data-testid="sticky-cta-quote-mobile"
            className="flex-1 min-w-0 inline-flex items-center justify-center gap-2 h-12 rounded-2xl bg-[#4CAF50] hover:bg-[#43A047] text-white font-semibold btn-primary-glow active:scale-[0.99] transition-transform"
          >
            <span className="truncate">Get Your Free Quote</span>
            <ArrowRight className="h-4 w-4 flex-shrink-0" />
          </Link>
        </div>
      </div>

      {/* Desktop floating button (left side to avoid Emergent badge) */}
      <Link
        to="/contact"
        data-testid="sticky-cta-desktop"
        className="hidden md:inline-flex fixed bottom-6 left-6 z-[60] items-center gap-2.5 h-12 px-5 rounded-full bg-[#4CAF50] hover:bg-[#43A047] text-white font-semibold btn-primary-glow shadow-soft-lg transition-transform hover:-translate-y-0.5"
      >
        <MessageSquareText className="h-4 w-4" />
        Get a Quote in 60 seconds
        <ArrowRight className="h-4 w-4" />
      </Link>
    </>
  );
}
